import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import MinorRequestDetailsMobile from '../molecules/MinorRequestDetailsMobile';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';

export default function DeliverModalMobile({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [usarDoc, setUsarDoc] = useState(false);

  const handleUsarDocChange = (event) => {
    setUsarDoc(event.target.checked);
  };

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const handleAtualizadoSGRSChange = (event) => {
    setAtualizadoSGRS(event.target.checked);
  };

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  const onSubmit = async (data) => {
    console.log(data);

    const dataHoraRecebimento = new Date().toISOString();

    data = { 
      ...data, 
      status: "ENTREGUE", 
      dataHoraRecebimento: dataHoraRecebimento
    };

    const response = await RequestService.sendToDelivery(requestId, data);

    if (response) {
      toast.success("Pedido entregue!");
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-60"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="relative w-full max-w-md mx-auto my-4 bg-white rounded-xl shadow-lg overflow-y-auto max-h-[95vh]">
          {/* Botão de fechar */}
          <button
            onClick={onClose}
            className="absolute top-1 right-2 z-10 bg-white rounded-full shadow p-1"
            aria-label="Fechar"
          >
            <IoIosClose color={"black"} size={36} />
          </button>

          {/* Cabeçalho */}
          <div className="flex flex-col gap-1 px-4 pt-4 pb-2 bg-gray-800 text-white rounded-t-xl">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="flex gap-2 text-lg font-bold">
                <MdSend />
                REGISTRAR ENTREGA
              </div>
              {requestObject?.request?.isReplica && (
                <span className="text-xs font-bold rounded px-2 py-1 bg-yellow-300 text-black">
                  RÉPLICA SGRS
                </span>
              )}
            </div>
            <div className="flex flex-wrap gap-2 text-xs mt-1">
              <span>
                Solicitação nº: {requestObject?.request?.idRequest}
              </span>
              <span>
                Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
              </span>
              <span className="flex items-center gap-1">
                Status:
                <span
                  className="text-black rounded px-2"
                  style={{
                    backgroundColor: StatusRequests[requestObject?.request?.status]?.cor,
                  }}
                >
                  {requestObject?.request?.status}
                </span>
              </span>
            </div>
          </div>

          {/* Detalhes do pedido */}
          <div className="px-4 py-2">
            <MinorRequestDetailsMobile request={requestObject?.request} divContato={true} />
          </div>

          {/* Formulário */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3 px-4 pb-4 text-xs">
            <div className="flex flex-col gap-2">
              <label className="font-bold text-gray-700">Recebido por:</label>
              <input
                type="text"
                {...register("recebidoPor", { required: true })}
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                ${errors?.recebidoPor?.type === "required"
                    ? " border border-red-500 outline-none ring-0"
                    : "border border-zinc-500 outline-none ring-0"
                  }
              `}
              />
              {errors?.recebidoPor?.type === "required" && (
                <p className="text-red-500 text-xs ms-2">Campo obrigatório</p>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex justify-between items-center">
                <label className="font-bold text-gray-700">Matrícula Recebedor:</label>
                <div className="flex gap-2 items-center">
                  <label className="text-gray-700">Usar Doc</label>
                  <input
                    id="usarDoc"
                    type="checkbox"
                    checked={usarDoc}
                    onChange={handleUsarDocChange}
                    className="form-checkbox h-4 w-4 text-blue-600"
                  />
                </div>
              </div>
              <input
                disabled={usarDoc}
                type="text"
                {...register("matriculaRecebedor", {
                  required: usarDoc ? false : true,
                })}
                className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 disabled:bg-gray-200
                ${errors?.matriculaRecebedor?.type === "required"
                    ? " border border-red-500 outline-none ring-0"
                    : "border border-zinc-500 outline-none ring-0"
                  }
              `}
              />
              {errors?.matriculaRecebedor?.type === "required" && (
                <p className="text-red-500 text-xs ms-2">Campo obrigatório</p>
              )}
            </div>

            {usarDoc && (
              <div className="flex flex-col gap-2">
                <label className="font-bold text-gray-700">Nº do Documento do Recebedor:</label>
                <input
                  type="text"
                  {...register("docRecebedor", { required: true })}
                  className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                  ${errors?.docRecebedor?.type === "required"
                      ? " border border-red-500 outline-none ring-0"
                      : "border border-zinc-500 outline-none ring-0"
                    }
                `}
                />
                {errors?.docRecebedor?.type === "required" && (
                  <p className="text-red-500 text-xs ms-2">Campo obrigatório</p>
                )}
              </div>
            )}

            <div className="flex flex-col gap-2">
              <label className="font-bold text-gray-700">Observação:</label>
              <textarea
                {...register("obsAtualizacao", { required: true })}
                className={`w-full h-[70px] p-4 bg-white rounded-2xl resize-none text-neutral-600 font-normal
                focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                placeholder:text-neutral-400 placeholder:font-normal
                ${errors?.obsAtualizacao?.type === "required"
                    ? "border border-red-500 outline-none ring-0"
                    : "border border-zinc-500 outline-none ring-0"
                  }
              `}
                placeholder={"Observação"}
              ></textarea>
              {errors?.obsAtualizacao?.type === "required" && (
                <p className="text-red-500 text-xs whitespace-nowrap">Campo obrigatório</p>
              )}
            </div>

            {requestObject?.request?.isReplica && (
              <div className="flex gap-2 items-center">
                <input
                  type="checkbox"
                  checked={atualizadoSGRS}
                  onChange={handleAtualizadoSGRSChange}
                  className="form-checkbox h-4 w-4 text-blue-600"
                />
                <label className="text-gray-700 font-bold whitespace-nowrap">
                  Confirmo que já atualizei no SGRS
                </label>
              </div>
            )}

            <button
              type="submit"
              disabled={requestObject?.request?.isReplica ? !atualizadoSGRS : false}
              className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 mt-2 disabled:bg-gray-200"
            >
              Enviar
            </button>
          </form>
        </div>
      </div>
    );
  }
}
